module.exports = __webpack_public_path__ + "media/alarm.mp3";